import * as React from 'react';

const CheckmarkShield16 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 16 16", width: 16, height: 16, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M8 0C6.273 0 4.242.861 2.57 1.57l-.576.244c-.55.23-.996.556-.994 1.12v.096l.005.882c.007 1.434.016 3.207.016 3.751 0 3.696 4.157 6.824 6.055 8.06.568.37 1.28.37 1.848 0 1.898-1.236 6.055-4.364 6.055-8.06 0-.533.008-2.245.016-3.663L15 2.936c.003-.565-.444-.892-.994-1.122l-.577-.243C11.758.86 9.727 0 8 0m.004 9.732a.74.74 0 0 1-1.061 0L4.54 7.29a.773.773 0 0 1 0-1.08.74.74 0 0 1 1.061 0l1.871 1.904 3.473-3.532a.74.74 0 0 1 1.061 0 .773.773 0 0 1 0 1.08z"
  }
));
CheckmarkShield16.Size = 16;
CheckmarkShield16.Title = "CheckmarkShield";

export { CheckmarkShield16 as default };
